import React from "react";

export function HealthGauge({ score, size = 140 }) {
    const radius = (size - 16) / 2;
    const circumference = 2 * Math.PI * radius;
    const pct = Math.max(0, Math.min(100, score)) / 100;
    const dashoffset = circumference * (1 - pct);
    const tier = score >= 80 ? "green" : score >= 50 ? "yellow" : "red";
    const fillClass = `health-fill-${tier}`;
    const colorMap = { green: "#10b981", yellow: "#f59e0b", red: "#ef4444" };
    return (
        <div
            className="relative inline-flex items-center justify-center"
            style={{ width: size, height: size }}
            data-testid="health-gauge"
        >
            <svg width={size} height={size} className="-rotate-90">
                <circle cx={size / 2} cy={size / 2} r={radius} className="health-track" strokeWidth="6" fill="none" />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    className={fillClass}
                    strokeWidth="6"
                    strokeLinecap="butt"
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={dashoffset}
                    style={{ transition: "stroke-dashoffset 600ms ease-out" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div
                    className="font-mono text-3xl font-semibold"
                    style={{ color: colorMap[tier] }}
                    data-testid="health-score-value"
                >
                    {score}
                </div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">
                    Health
                </div>
            </div>
        </div>
    );
}
